<template>
  <v-app>
    <v-main>
      <LSIMensajes />
      <MenuPrincipal :tituloPrincipal="TituloMenuPrincipal" class="py-0"></MenuPrincipal>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>

import MenuPrincipal from './components/MenuPrincipal';
import LSIMensajes from 'vue-lsi-util'

import store from './store'
import router from './router'
import axios from "axios"

export default {
  name: 'App',

  components: {
    MenuPrincipal, LSIMensajes 
  },

  data: () => ({
    //
  }),

  methods: {
    alertDialogOcultar(cualBotonApretado) {
      store.dispatch("alertDialog/ocultar", cualBotonApretado)
    }
  },

  computed: {
    textoAMostrar() {
      return store.state.snackbar.textoAMostrar
    },
    cartelAMostrar() {
      return store.state.loading.cartelAMostrar
    },
    TituloMenuPrincipal() {
      return this.TituloPrincipal
    },
    alertDialog() {
      return store.state.alertDialog.textoAMostrar
    }
  },

  created() {
    //axios.defaults.baseURL="https://apiv2.area54sa.com.ar:8123/apiv2/"

    if (typeof localStorage.choferNumero !== "undefined") {
      store.dispatch('choferes/actualizar', {loggeado:true, numero: localStorage.choferNumero, nombre: localStorage.choferNombre})
      router.replace("/")
    } else {
      router.replace("/Configurar")
    }
  },
  
  watch: {
    '$route' (to, from) {
      document.title = to.meta.tituloPagina || 'Area 54'
    }
  }
}

</script>
